import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { safeStorage } from '@/state/storage'

// Per-widget-instance collapse override for the Active tab's four sections
// (Orders, Hedges, Triggers, RFQ). `undefined` per key means "use this
// section's own default" — every section on the Active tab defaults to open,
// since everything here is actionable (contrast with the History/"Activity"
// tab's historyTabSectionCollapseByInstanceAtom, where secondary sections
// default collapsed). An explicit true/false means the user overrode it.
// Persisted so the override survives a reload.
export interface ActiveTabSectionCollapse {
  orders?: boolean
  hedges?: boolean
  triggers?: boolean
  rfq?: boolean
  arb?: boolean
  spreader?: boolean
  advancedTwap?: boolean
}

// A live OPEN notification can arrive while every Positions widget is showing
// another tab, so ActiveTable's row-diff effect is not mounted and cannot see
// the row being added. Keep the latest request in memory until a matching
// account/order row is visible in a widget; that widget then opens Orders once.
export interface ActiveOrderOpenRequest {
  id: string
  accountId: string
  orderId: string
}

export const activeOrderOpenRequestAtom = atom<ActiveOrderOpenRequest | null>(null)

// "Show me the hedge I just started": StartAlgo only answers with a plain success (no algo id),
// so the new hedge is matched when its row arrives over the WS — the newest HEDGE row on this
// account created at/after startedAt — in the Active view of `cardId`, which then selects it
// (opening its details). Dropped after HEDGE_OPEN_REQUEST_TTL_MS if it never shows up.
export interface ActiveHedgeOpenRequest {
  id: string
  cardId: string
  accountId: string
  startedAt: number
}

export const HEDGE_OPEN_REQUEST_TTL_MS = 30_000

export const activeHedgeOpenRequestAtom = atom<ActiveHedgeOpenRequest | null>(null)

export const activeTabSectionCollapseByInstanceAtom = atomWithStorage<
  Record<string, ActiveTabSectionCollapse>
>(`dashboard-active-tab-section-collapse-${process.env.NEXT_PUBLIC_ENV}`, {}, safeStorage, {
  getOnInit: true,
})
